import * as Sentry from '@sentry/angular';
import {BrowserTracing} from '@sentry/tracing';
import {inject} from '@angular/core';
import {EnvironmentService} from '@services/environment/environment.service';

/* istanbul ignore next */
export function initSentry() {
  const environmentService = inject(EnvironmentService);
  Sentry.init({
    environment: environmentService.env,
    dsn: 'https://a2e4f820e2294717aba5992c62057d65@o452613.ingest.sentry.io/6409038',
    integrations: [new BrowserTracing()],
    tracesSampleRate: 0.1,
    beforeSend(event, hint) {
      /* tslint:disable:no-string-literal only-arrow-functions */
      const isNonErrorException =
        event.exception.values[0].value.startsWith('Non-Error exception captured') ||
        hint.originalException['message'].startsWith('Non-Error exception captured');
      /* tslint:enable:no-string-literal only-arrow-functions */

      if (isNonErrorException) {
        // We want to ignore those kind of errors
        return null;
      }
      return event;
    }
  });
}
